import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { metaSugestaoApi } from '../api/metaSugestao';
import type { SugestaoMetaFiltros } from '../types/metaSugestao';

const KEY = 'meta-sugestao';
const STALE = 5 * 60 * 1000;

/** Debounce genérico — evita disparar query em cada keystroke do autocomplete. */
function useDebounced<T>(value: T, delayMs: number): T {
  const [d, setD] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setD(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return d;
}

/**
 * Calcula sugestão de meta baseada no último trimestre fechado. Debounce 400ms
 * pra absorver typing do autocomplete (código de dimensão muda rápido).
 *
 * Só dispara quando há empresas e (sem dimensão OU com dimensão + código).
 */
export function useMetaSugestao(filtros: SugestaoMetaFiltros) {
  const debounced = useDebounced(filtros, 400);
  const habilitado =
    debounced.empresas.length > 0 &&
    (!debounced.dimensao || (!!debounced.dimensao && !!debounced.codigo));

  return useQuery({
    queryKey: [KEY, debounced],
    queryFn: () => metaSugestaoApi.calcular(debounced),
    enabled: habilitado,
    staleTime: STALE,
  });
}
